/* VH Contact (sections/vh-contact.liquid). PRESENTATION ONLY. The Zendesk form's own script (copied verbatim in the section)
   does everything form-related; this file only sets the "open now" badge and the intro motion. No network calls. */
(function () {
  var root = document.getElementById('vh-contact');
  if (!root) return;

  /* open-now badge: business hours Mon-Fri, open_hour to close_hour, in the section's time zone, against the visitor's clock */
  var h = document.getElementById('vh-contact-hours');
  if (h && window.Intl && Intl.DateTimeFormat) {
    try {
      var parts = {};
      new Intl.DateTimeFormat('en-US', {timeZone: h.getAttribute('data-tz') || 'America/Mexico_City', weekday: 'short', hour: 'numeric', hourCycle: 'h23'})
        .formatToParts(new Date()).forEach(function (x) { parts[x.type] = x.value; });
      var hr = +parts.hour % 24, open = ['Sat', 'Sun'].indexOf(parts.weekday) === -1 && hr >= +h.getAttribute('data-open') && hr < +h.getAttribute('data-close');
      var label = h.getAttribute(open ? 'data-t-open' : 'data-t-closed');
      if (label) h.querySelector('b').textContent = label;
      h.classList.add(open ? 'is-open' : 'is-closed');
    } catch (e) { /* unknown time zone: keep "Business Hours" */ }
  }

  if (window.VHK) {
    VHK.withGsap(function (ok) {
      if (!ok) return;
      gsap.from(VHK.$$('.vh-contact-copy > *', root).concat(VHK.$$('.contact-form-card', root)), {autoAlpha: 0, y: 30, duration: 1, stagger: 0.07, ease: 'power3.out', delay: 0.1, clearProps: 'transform'});
    });
  }
})();
